import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useCall } from '../../customer-call-sdk';
import { Business } from '../../types/business.type';
import BusinessDetail from './BusinessDetail/BusinessDetail';
import DefaultBusinessDirectory from './DefaultBusinessDirectory';
import SearchBusinessDirectory from './SearchBusinessDirectory';
import { BusinessDisplayUnit } from '../../types/business-group-type';
import { GetBusinessByIdResult, getBusinessListById } from '../../services/business.service';
import VideoRecorderDialog from '../VideoMail/VideoRecorder/VideoRecorderDialog';
import AlertDialogVideoMail from '../VideoMail/AlertDialog';

const StyledServiceDirectory = styled.div`
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;

    .dark-screen::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: '';
        z-index: 666;
        background-color: rgba(0, 0, 0, 0.8);
    }
`;

const ServiceDirectory: React.FC = () => {
    const [isSearch, setIsSearch] = useState<boolean>(false);
    const [isOpenBusinessDetailModal, setIsOpenBusinessDetailModal] = useState<boolean>(false);
    const [business, setBusiness] = useState<Business>();
    const call = useCall();

    const handleCallClick = (number: string) => {
        call.makeCall({ toPhoneNumber: number });
    };
    const launchSearchModal = () => {
        setIsSearch(true);
    };

    const closeSearchModal = () => {
        setIsSearch(false);
    };

    const onBusinessSelect = (businessDetail: Business) => {
        setBusiness(businessDetail);
        setIsOpenBusinessDetailModal(true);
    };
    const closeBusinessDetail = () => {
        setIsOpenBusinessDetailModal(false);
    };

    const onBusinessDisplayUnitSelect = async (businessDisplayUnit: BusinessDisplayUnit) => {
        const result: GetBusinessByIdResult = await getBusinessListById(businessDisplayUnit.id);
        if (result.data) {
            onBusinessSelect(result.data.businessList[0]);
        }
    };

    useEffect(() => {
        if (call.videoMailDialogFlagVisible && call.isVideoMailAlertPopupVisible === false) {
            call.showVideoMailDialog();
        }
    }, [call.videoMailDialogFlagVisible]);

    useEffect(() => {
        if (call.isAlertPopupOnCancelVisible) {
            call.showVideoMailAlertDialog();
        }
    }, [call.isAlertPopupOnCancelVisible]);

    const closeVideoMailADialog = () => {
        call.setDialogFlagFalse();
        call.hideVideoMailDialog();
        call.handleMessageForVideoMail('');
        call.handleRequestIdForVedioMail('');
    };

    const onAlertDialogConfirmClick = () => {
        if (call.isVideoMailAlertPopupVisible) {
            call.hideVideoMailAlerDialog();
        }
        if (call.isAlertPopupOnCancelVisible) {
            call.hideAlertDialogOnCancel();
        }

        setTimeout(() => {
            call.showVideoMailDialog();
            call.setDialogFlagTrue();
        }, 200);
    };

    const onAlertDialogCancelClick = () => {
        if (call.isVideoMailAlertPopupVisible) {
            call.hideVideoMailAlerDialog();
        }
        if (call.isAlertPopupOnCancelVisible) {
            call.hideAlertDialogOnCancel();
        }
    };

    const renderBusinessDirectory = () => {
        if (isSearch) {
            return (
                <SearchBusinessDirectory
                    onSelect={onBusinessDisplayUnitSelect}
                    closeSearchModal={closeSearchModal}
                />
            );
        }
        return (
            <DefaultBusinessDirectory
                onSelect={onBusinessDisplayUnitSelect}
                launchSearchModal={launchSearchModal}
            />
        );
    };

    return (
        <>
            <StyledServiceDirectory>
                {renderBusinessDirectory()}
                {isOpenBusinessDetailModal && (
                    <div>
                        <div className="dark-screen" />
                        <BusinessDetail
                            business={business as Business}
                            closeBusinessDetail={closeBusinessDetail}
                            handleCallClick={handleCallClick}
                        />
                    </div>
                )}
            </StyledServiceDirectory>

            {call.isVideoMailAlertPopupVisible && (
                <AlertDialogVideoMail
                    isVideoMailAlertPopupVisible={call.isVideoMailAlertPopupVisible}
                    handleClose={onAlertDialogCancelClick}
                    handleConfirmClick={onAlertDialogConfirmClick}
                />
            )}

            {call.isVideoMailDialogVisible && call.requestIdForVedioMail && (
                <VideoRecorderDialog
                    requestId={call.requestIdForVedioMail}
                    showVideoDialog={call.isVideoMailDialogVisible}
                    handleCloseClick={closeVideoMailADialog}
                />
            )}
        </>
    );
};

export default ServiceDirectory;
